import React, { Component } from 'react';
import cn from 'classnames/bind';
import s from './Checkbox.scss';

const cx = cn.bind(s);

export default class Checkbox extends Component {
  onChange = (event) => {
    const { handle, checked } = this.props;
    handle(!checked);
    this.props.onChange && this.props.onChange(event);
  }

  render() {
    const {
        innerStyle,
        className,
        classNameClone,
        text,
        checked,
        type,
        name,
        partialChecked,
        additional
    } = this.props;

    return (
      <div className={cn(className, { [s.Radio]: type == 'radio' }, { [s.Additional]: additional })}>
        <label>
          <span className={cn(innerStyle, s.CheckboxInner, s.CheckboxInnerChecked)}>
            <input
              type="checkbox"
              name={name}
              onChange={this.onChange}
              ref={checkbox => { this._checkbox = checkbox; }}
              className={cx({ Checked: checked, PartialChecked: !checked && partialChecked }, s.Checkbox)}
            />
            <span className={cn(s.CheckboxClone, (classNameClone) ? s[classNameClone] : null)}><span><span></span></span></span>
            <span className={s.Text}>{text}</span>
          </span>
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/Checkbox.js